import {
  storyblokEditable,
  renderRichText,
  StoryblokComponent,
} from "@storyblok/react"
import { Button } from "../../ui/button"
import { motion } from "framer-motion"

const container = {
  hidden: { opacity: 0 },
  show: {
    opacity: 1,
    transition: { staggerChildren: 0.12, delayChildren: 0.05 },
  },
}

export default function Testimonials({ blok }: any) {
  const toPlain = (rich: any) =>
    (renderRichText(rich || { content: [] }) || "")
      .toString()
      .replace(/<[^>]+>/g, "")
      .replace(/\s+/g, " ")
      .trim()

  const cta = toPlain(blok?.ctaText)

  return (
    <section
      {...storyblokEditable(blok)}
      className="bg-white py-24 md:py-28 px-6 md:px-20"
    >
      <div className="max-w-6xl mx-auto">
        <div className="mb-10">
          <div
            className="font-['BeausiteClassic'] font-bold text-[24px] md:text-[32px] text-gray-900 text-center"
            dangerouslySetInnerHTML={{
              __html: renderRichText(blok.heading || { content: [] }) || "",
            }}
          />
          <span className="mt-3 mx-auto block h-[3px] w-16 rounded-full bg-gradient-to-r from-[#4750F5] to-[#8BA3FF]" />
        </div>

        <motion.div
          variants={container}
          initial="hidden"
          whileInView="show"
          viewport={{ once: true, amount: 0.25 }}
          className="grid gap-8 md:grid-cols-3"
        >
          {blok.items?.map((nestedBlok: any) => (
            <StoryblokComponent key={nestedBlok._uid} blok={nestedBlok} />
          ))}
        </motion.div>

        {cta && (
          <div className="mt-12 text-center">
            <Button asChild variant="default" size="lg">
              <a
                href={blok?.ctaLink?.url || blok?.ctaLink?.cached_url || "#"}
                target="_blank"
                rel="noopener noreferrer"
              >
                {cta}
              </a>
            </Button>
          </div>
        )}
      </div>
    </section>
  )
}
